import { useSelector, useDispatch } from "react-redux";
import React, { useEffect } from 'react';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { deviceConstants } from '../../redux/device/device.constants';
import { setLogin } from '../../redux/device/device.actions';
import { LoginComponent } from '../../components/login/login.component';
import { ErrorsComponent } from '../../components/error/errors.component';
import { errorConstants } from '../../redux/error/error.constants';

function ScanPage() {
    const dispatch = useDispatch();
    const [devicesSelector, errorReducer] = useSelector(state => [state.deviceReducer, state.errorReducer]);

    useEffect(() => {
        // If no page is active, activate login page as default
        // This ensures users coming from invalid routes see the login page
        if (!devicesSelector.isActive || 
            (devicesSelector.name !== deviceConstants.SET_LOGIN_PAGE && 
             devicesSelector.name !== deviceConstants.DEVICE)) {
            dispatch(setLogin(deviceConstants.SET_LOGIN_PAGE, true));
        }
    }, [])

    // Check if there's an error to display
    const hasError = (errorReducer.name === errorConstants.SET_ERROR || errorReducer.name === errorConstants.SET_ERROR_API) && errorReducer.isActive === true;
    
    return (
        <>
            <HeaderComponent />
            {hasError ? (
                <ErrorsComponent />
            ) : (
                <>
                    {devicesSelector.name === deviceConstants.SET_LOGIN_PAGE && devicesSelector.isActive === true ? <LoginComponent /> : ''}
                    {devicesSelector.name === deviceConstants.DEVICE && devicesSelector.isActive === true ? <ErrorsComponent /> : ''}
                </>
            )}
            <FooterComponent />
        </>
    );
}

export { ScanPage };